import {
  Defaults,
  Traits
} from './shared';

import { ICON_BUTTON_ARTICLE } from './../../../const/icons';

import { COMP_BUTTON_ARTICLE } from './../../../const/components';

import { FIELD_ARTICLE_SELECTOR } from './../../../const/traits';

import { PageFormLinkedItem } from './../page-form-linked-item';

export const Article = (editor, options:any = {}) => {

  (FIELD_ARTICLE_SELECTOR as any).at = 9;

  return PageFormLinkedItem(editor, {
    componentName: COMP_BUTTON_ARTICLE,
    displayIcon: ICON_BUTTON_ARTICLE,
    model: {
      defaults: { ...Defaults,
        name: 'Article',
        traits: [ ...Traits, FIELD_ARTICLE_SELECTOR]
      }
    }
  });
}